import { ChargeBeePlanId, isStarterPlanId } from '@prerender/billing-shared';

type StarterTrialKeepPlanInput = {
  oldPlanId: ChargeBeePlanId;
  newPlanId: ChargeBeePlanId;
  isInTrial: boolean;
};

type ImmediateStarterTrialActivationInput = StarterTrialKeepPlanInput & {
  activateNow?: boolean;
};

export function isStarterTrialKeepPlanScenario({
  oldPlanId,
  newPlanId,
  isInTrial,
}: StarterTrialKeepPlanInput): boolean {
  return isStarterPlanId(oldPlanId) && isStarterPlanId(newPlanId) && isInTrial;
}

export function isImmediateStarterTrialActivation({
  oldPlanId,
  newPlanId,
  isInTrial,
  activateNow,
}: ImmediateStarterTrialActivationInput): boolean {
  return isStarterTrialKeepPlanScenario({ oldPlanId, newPlanId, isInTrial }) && activateNow === true;
}
